(function($) {
	'use strict';

	var scrollLast = 0;
	var stickBottom = 0;
	var stickTop = 0;

	function initSticky(element) {
		var $placeholder = $('<div>');
		$placeholder.attr('data-sticky-placeholder', '');
		$(element).prepend($placeholder);
	}

	function isItSticky(element, windowTop) {
		var $elementInner = $(element).find('[data-sticky-inner]');
		var $elementPlaceholder = $(element).find('[data-sticky-placeholder]');

		var elementHeight = $elementInner.height();
		var elementWidth = $elementPlaceholder.width();
		var elementLeft = $elementPlaceholder.offset().left;
		var elementTop = $elementPlaceholder.offset().top;
		var elementBottom = elementTop + elementHeight;

		var scrollingUp = false;
		if (windowTop < scrollLast) { //scrolling up
			scrollingUp = true;
			stickTop = windowTop;
		} else { //scrolling down
			stickBottom = windowTop;
		}

		scrollLast = windowTop;

		if (windowTop > elementTop) { //stick
			$elementInner.addClass('sticky');
			$elementInner.css('left', '0');
			$elementInner.css('top', '0');
			$elementInner.css('width', elementWidth + 'px');
			$elementPlaceholder.css('height', elementHeight + 'px');

			if (elementLeft > 0) { //larger than small screen
				$elementInner.css('left', elementLeft + 'px');

				//set top position
				if (scrollingUp) { //scrolling up
					if (elementHeight - (stickBottom - windowTop) > 0) {
						//console.log('top: ' + -Math.abs(elementHeight - (stickBottom - windowTop)) + 'px UP A');
						$elementInner.css('top', -Math.abs(elementHeight - (stickBottom - windowTop)) + 'px');
					} else {
						//console.log('top: 0px UP B');
						$elementInner.css('top', '0px');
					}
				} else { //scrolling down
					if ((elementHeight + (windowTop - elementBottom)) < elementHeight) {
						//console.log('top: ' + -Math.abs(elementHeight + (windowTop - elementBottom)) + 'px DOWN A');
						$elementInner.css('top', -Math.abs(elementHeight + (windowTop - elementBottom)) + 'px');
					} else {
						//NEED TO FIX THE JUMP WHICH I THINK IS COMING FROM HERE
						//console.log('top: ' + -Math.abs(windowTop - stickTop) + 'px DOWN B');
						$elementInner.css('top', -Math.abs(windowTop - stickTop) + 'px');
					}
				}
			}
		} else { //unstick
			$elementInner.removeClass('sticky');
			$elementInner.removeAttr('style');
			$elementPlaceholder.removeAttr('style');
		}
	}

	var $stickies = $('[data-sticky]');

	$stickies.each(function(index, element) {
		initSticky(element);
	});

	$(window).on('resize scroll', function() {
		var windowTop = $(window).scrollTop();

		$stickies.each(function(index, element) {
			isItSticky(element, windowTop);
		});
	});

})($jq);
